import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DocDrawer from "./modules/DocDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { querySysCategoryTreeList, DocListByCategory } from '@/api/api';
export default {
  name: 'DocList',
  mixins: [JeecgListMixin],
  components: {
    DocDrawer: DocDrawer
  },
  data: function data() {
    return {
      iExpandedKeys: [],
      autoExpandParent: true,
      description: '知识库管理页面',
      categoryTree: [],
      showBtn: true,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '标题',
        align: 'center',
        dataIndex: 'title'
      }, {
        title: '类别',
        align: 'center',
        dataIndex: 'categoryName'
      }, {
        title: '关键字',
        align: 'center',
        dataIndex: 'keyword'
      }, {
        title: '排序号',
        align: 'center',
        dataIndex: 'sort'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: '/sys/doc/list',
        delete: '/sys/doc/delete',
        deleteBatch: '/sys/doc/deleteBatch',
        exportXlsUrl: '/sys/doc/exportXls',
        importExcelUrl: '/sys/doc/importExcel'
      },
      selectedKeysDoc: 1,
      categoryTreeKey: ''
    };
  },
  watch: {
    $route: {
      handler: function handler(to, form) {
        this.autoLoadInit = false;

        if (to.path !== form.path) {
          var ss = this.$route.path.split("/");
          this.selectedKeysDoc = ss[ss.length - 1];
          this.queryCategoryTreeList();
        }
      },
      deep: true
    }
  },
  created: function created() {
    if (this.autoLoadInit) {
      var ss = this.$route.path.split("/");
      this.selectedKeysDoc = ss[ss.length - 1];
      this.queryCategoryTreeList();
    }
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    handleAdd: function handleAdd() {
      this.$refs.modalForm.add({
        category: this.selectedKeysDoc
      });
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    // 类别tree
    queryCategoryTreeList: function queryCategoryTreeList() {
      var _this = this;

      var that = this;
      that.categoryTree = [];
      var param = {
        pid: this.selectedKeysDoc
      };
      querySysCategoryTreeList(param).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.categoryTree.push(temp);
            that.setThisExpandedKeys(temp);
          }

          _this.loading = false;
        }

        _this.onTreeSelect([that.categoryTree[0].key]);
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);

        for (var a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    onTreeSelect: function onTreeSelect(selectedKeys, info) {
      var _this2 = this;

      this.categoryTreeKey = selectedKeys;
      this.loading = true;
      this.dataSource = [];

      if (selectedKeys.length <= 0) {
        this.loadData();
      }

      var param = {
        category: selectedKeys[0]
      };
      this.selectedKeysDoc = selectedKeys[0];
      DocListByCategory(param).then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result.records;
        }

        _this2.loading = false;
      });
    },
    onExpand: function onExpand(selectedKeys) {
      console.log('onExpand', selectedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      this.iExpandedKeys = selectedKeys;
      this.autoExpandParent = false;
    }
  }
};